var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Interactor, SORT_DIRECTION } from '@veeam/core';
import { Subscription } from 'rxjs';
import { LocalDataGridPersistentStorage } from "./LocalDataGridPersistentStorage";
import { distinctUntilChanged, map } from 'rxjs/operators';
import { InMemoryDataGridPersistentStorage } from "./InMemoryDataGridPersistentStorage";
var DataGridInteractor = /** @class */ (function (_super) {
    __extends(DataGridInteractor, _super);
    function DataGridInteractor(model, config) {
        var _this = _super.call(this) || this;
        _this.model = model;
        _this.config = config;
        _this.subscriptions = new Subscription();
        _this.firstSortDirection = SORT_DIRECTION.asc;
        return _this;
    }
    DataGridInteractor.prototype.didActivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.subscriptions.add(this.model.fieldChanges('pagination').subscribe(function () {
                            _this.model.load();
                        }));
                        this.subscriptions.add(this.model.fieldChanges('sorting').subscribe(function () {
                            _this.model.load();
                        }));
                        this.subscriptions.add(this.model.fieldChanges('filters').subscribe(function () {
                            var _a;
                            if (!((_a = _this.model.getValue().pagination) === null || _a === void 0 ? void 0 : _a.offset)) {
                                _this.model.load();
                                return;
                            }
                            _this.model.update(function (prev) {
                                if (prev.pagination) {
                                    prev.pagination.offset = 0;
                                }
                            });
                        }));
                        this.subscriptions.add(this.model
                            .getMetaAsObservable()
                            .pipe(map(function (item) { return item.outdated; }))
                            .pipe(distinctUntilChanged())
                            .subscribe(function (outdated) {
                            var _a, _b;
                            if (outdated) {
                                (_a = _this.presenter) === null || _a === void 0 ? void 0 : _a.showOutdatedNotification();
                                return;
                            }
                            (_b = _this.presenter) === null || _b === void 0 ? void 0 : _b.dismissNotification();
                        }));
                        if (!this.config.autoLoad) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.model.load()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataGridInteractor.prototype.willDeactivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.subscriptions.unsubscribe();
                return [2 /*return*/];
            });
        });
    };
    DataGridInteractor.prototype.toggleSort = function (key) {
        var _this = this;
        this.model.update(function (prevValue) {
            var _a, _b;
            var sorting = (_b = (_a = prevValue.sorting) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
            var prevDirection = sorting && sorting.key === key ? sorting.direction : null;
            if (prevDirection === null) {
                prevValue.sorting = [{ key: key, direction: _this.firstSortDirection }];
                return;
            }
            if (_this.config.hasNoneSort && prevDirection !== _this.firstSortDirection) {
                prevValue.sorting = [];
                return;
            }
            var nextDirection = prevDirection === SORT_DIRECTION.asc ? SORT_DIRECTION.desc : SORT_DIRECTION.asc;
            prevValue.sorting = [
                {
                    key: key,
                    direction: nextDirection
                }
            ];
        });
    };
    DataGridInteractor.prototype.isSelectAll = function () {
        var _this = this;
        var _a;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.isRowDisabled) {
            return this.model.isAllItemsSelected(function (item, index) {
                var _a, _b;
                return !((_b = (_a = _this.config) === null || _a === void 0 ? void 0 : _a.isRowDisabled) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    rowData: item,
                    rowIndex: index,
                    id: _this.model.getItemID(item)
                }));
            });
        }
        return this.model.isAllItemsSelected();
    };
    DataGridInteractor.prototype.hasPagination = function () {
        var value = this.model.getValue();
        return value.pagination && value.totalCount && value.totalCount > value.pagination.limit;
    };
    DataGridInteractor.prototype.didPageChange = function (nextPage) {
        this.model.update(function (prevValue) {
            if (prevValue.pagination) {
                prevValue.pagination.offset = (nextPage - 1) * prevValue.pagination.limit;
            }
        });
    };
    DataGridInteractor.prototype.didSelectAllChange = function () {
        var _this = this;
        var nextIsAllSelected = !this.isSelectAll();
        this.model.update(function (prevValue) {
            var _a, _b;
            if (!nextIsAllSelected) {
                prevValue.selection = [];
                return;
            }
            var nextValue = [];
            var items = _this.model.getValue().items;
            for (var idx = 0; idx < items.length; idx++) {
                var item = items[idx];
                var id = _this.model.getItemID(item);
                if ((_b = (_a = _this.config) === null || _a === void 0 ? void 0 : _a.isRowDisabled) === null || _b === void 0 ? void 0 : _b.call(_a, { rowData: item, rowIndex: idx, id: id })) {
                    continue;
                }
                nextValue.push(id);
            }
            prevValue.selection = nextValue;
        });
    };
    DataGridInteractor.prototype.didSelectionChange = function (nextSelection) {
        this.model.update(function (prevValue) {
            prevValue.selection = nextSelection;
        });
    };
    DataGridInteractor.prototype.getPersistConfig = function () {
        var _a, _b, _c;
        var storage = this.getPersistentStorage();
        var columnSizes = (_a = storage.read().columnSizes) !== null && _a !== void 0 ? _a : {};
        var columnVisibility = (_b = storage.read().columnVisibility) !== null && _b !== void 0 ? _b : {};
        var columnOrders = (_c = storage.read().columnOrders) !== null && _c !== void 0 ? _c : {};
        return {
            columnSizes: columnSizes,
            columnVisibility: columnVisibility,
            columnOrders: columnOrders
        };
    };
    DataGridInteractor.prototype.didColumnSizeChange = function (payload) {
        var _a;
        var storage = this.getPersistentStorage();
        var prevData = storage.read();
        storage.save(Object.assign({}, prevData, {
            columnSizes: Object.assign({}, prevData.columnSizes, (_a = {},
                _a[payload.columnId] = payload.width,
                _a))
        }));
    };
    DataGridInteractor.prototype.didColumnOrderChange = function (payload) {
        var storage = this.getPersistentStorage();
        var prevData = storage.read();
        storage.save(Object.assign({}, prevData, {
            columnOrders: payload
        }));
    };
    DataGridInteractor.prototype.didColumnVisibilityChange = function (payload) {
        var _a;
        var storage = this.getPersistentStorage();
        var prevData = storage.read();
        storage.save(Object.assign({}, prevData, {
            columnVisibility: Object.assign({}, prevData.columnVisibility, (_a = {},
                _a[payload.columnId] = payload.isShown,
                _a))
        }));
    };
    DataGridInteractor.prototype.didSelectApplyFreshData = function () {
        this.model.applyFreshData();
    };
    DataGridInteractor.prototype.didSelectIgnoreFreshData = function () {
        this.model.dropFreshData();
    };
    DataGridInteractor.prototype.getPersistentStorage = function () {
        var _a, _b, _c, _d, _e, _f;
        return (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.persistent) === null || _b === void 0 ? void 0 : _b.storage) ||
            (((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.persistent) === null || _d === void 0 ? void 0 : _d.key) ? new LocalDataGridPersistentStorage((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.persistent) === null || _f === void 0 ? void 0 : _f.key)
                : new InMemoryDataGridPersistentStorage()));
    };
    return DataGridInteractor;
}(Interactor));
export { DataGridInteractor };
//# sourceMappingURL=DataGridInteractor.js.map